<!-- BSG-compliant menu popover with keyboard accessibility -->
<div class="wrapper bsg-menu-popover" role="dialog" aria-labelledby="menu-title">
	<div class="bsg-menu-content">
		<!-- Close button with keyboard accessibility -->
		<ion-row class="header-btn">
			<button (click)="dismiss()" class="bsg-close-button" aria-label="Close menu" tabindex="0">
				<ion-icon size="large" name="close" src="../../../assets/dean_and_david/cross.svg" aria-hidden="true"></ion-icon>
			</button>
		</ion-row>

		<!-- User info header -->
		<ion-col>
			<div class="header-wrap" id="menu-title">
				<h3 class="name">{{ customer?.isAnonymous ? ('menu_popover.guest' | translate) : customer?.name }}</h3>
				<p class="email" *ngIf="!customer?.isAnonymous">{{ customer?.email }}</p>
			</div>
		</ion-col>

		<!-- Navigation options with keyboard accessibility -->
		<nav class="bsg-menu-nav" *ngIf="customer">
			<!-- Anonymous user menu options -->
			<ng-container *ngIf="customer.isAnonymous">
				<button class="bsg-menu-item" (click)="signIn()" tabindex="0">
					<ion-icon src="/assets/dean_and_david/burger-menu/login.svg" aria-hidden="true"></ion-icon>
					<ion-col>
						{{ 'menu_popover.login' | translate }}
					</ion-col>
				</button>

				<button class="bsg-menu-item" (click)="signUp()" tabindex="0">
					<ion-icon src="/assets/dean_and_david/burger-menu/registration.svg" aria-hidden="true"></ion-icon>
					<ion-col>
						{{ 'menu_popover.register' | translate }}
					</ion-col>
				</button>
			</ng-container>

			<!-- Logged in user menu options -->
			<ng-container *ngIf="!customer?.isAnonymous">
				<button class="bsg-menu-item" (click)="myPromo()" tabindex="0">
					<ion-icon src="/assets/promo.svg" aria-hidden="true"></ion-icon>
					<ion-col>
						{{ 'menu_popover.promo' | translate }}
					</ion-col>
				</button>
			</ng-container>

			<button class="bsg-menu-item" (click)="myOrders()" tabindex="0">
				<ion-icon src="/assets/dean_and_david/burger-menu/my_orders.svg" aria-hidden="true"></ion-icon>
				<ion-col>
					{{ 'menu_popover.orders' | translate }}
				</ion-col>
			</button>

			<button *ngIf="!customer?.isAnonymous" class="bsg-menu-item" (click)="account()" (keydown.enter)="account()" tabindex="0">
				<ion-icon src="/assets/dean_and_david/burger-menu/my_data.svg" aria-hidden="true"></ion-icon>
				<ion-col>
					{{ 'menu_popover.account' | translate }}
				</ion-col>
			</button>

			<a class="bsg-menu-item underline" (click)="allergens($event)" target="_blank" tabindex="0">
				<ion-icon src="/assets/dean_and_david/burger-menu/allergen.svg" aria-hidden="true"></ion-icon>
				<ion-col>
					{{ 'menu_popover.allergens' | translate }}
				</ion-col>
			</a>

			<ion-row (click)="accessibility()" role="button" tabindex="0">
				<ion-icon src="/assets/dean_and_david/burger-menu/faq.svg" role="img"></ion-icon>
				<ion-col>
					{{ 'menu_popover.accessibility' | translate }}
				</ion-col>
			</ion-row>
		</nav>

		<!-- Loading spinner -->
		<div *ngIf="!customer" class="bsg-loading">
			<ion-row class="ion-justify-content-center">
				<ion-spinner class="white" name="crescent" aria-label="Loading..."></ion-spinner>
			</ion-row>
		</div>

		<!-- Legal info navigation -->
		<nav class="bsg-legal-nav">
			<button class="bsg-menu-item" (click)="privacy()" tabindex="0">
				<ion-icon src="assets/dean_and_david/burger-menu/privacy.svg" aria-hidden="true"></ion-icon>
				<ion-col>
					{{ 'menu_popover.privacy' | translate }}
				</ion-col>
			</button>

			<button class="bsg-menu-item" (click)="tos()" tabindex="0">
				<ion-icon src="/assets/dean_and_david/burger-menu/faq.svg" aria-hidden="true"></ion-icon>
				<ion-col>
					{{ 'menu_popover.terms' | translate }}
				</ion-col>
			</button>

			<ng-container *ngIf="!checkIfVenueExistImpressum">
				<button class="bsg-menu-item" (click)="impressum()" tabindex="0">
					<ion-icon src="/assets/dean_and_david/burger-menu/impressum.svg" aria-hidden="true"></ion-icon>
					<ion-col>
						{{ 'menu_popover.imprint' | translate }}
					</ion-col>
				</button>
			</ng-container>

			<ng-container *ngIf="checkIfVenueExistImpressum">
				<a class="bsg-menu-item underline" [href]="checkIfVenueExistImpressum" target="_blank" tabindex="0">
					<ion-icon src="/assets/dean_and_david/burger-menu/impressum.svg" aria-hidden="true"></ion-icon>
					<ion-col>
						{{ 'menu_popover.imprint' | translate }}
					</ion-col>
				</a>
			</ng-container>

			<button class="bsg-menu-item" (click)="cookie()" tabindex="0">
				<ion-icon color="secondary" name="document" aria-hidden="true"></ion-icon>
				<ion-col>
					{{ 'menu_popover.cookie' | translate }}
				</ion-col>
			</button>
		</nav>

		<!-- Version info -->
		<span class="version" aria-label="Version">{{ environment.version }}</span>
	</div>

	<!-- Footer with language switcher -->
	<div class="footer-block">
		<!-- Language selection with keyboard accessibility -->
		<div class="lang-block" role="radiogroup" aria-label="Language selection">
			<button
				[class.selected]="languageEnum.German === translate.currentLang"
				(click)="changeLang(languageEnum.German)"
				class="lang-item bsg-lang-button"
				role="radio"
				[attr.aria-checked]="languageEnum.German === translate.currentLang"
				tabindex="0"
			>
				<ion-icon src="../../../assets/dean_and_david/lang/de.svg" aria-hidden="true"></ion-icon>
				<h3>{{ 'DE' | translate }}</h3>
			</button>

			<button
				[class.selected]="languageEnum.GreatBritain === translate.currentLang"
				(click)="changeLang(languageEnum.GreatBritain)"
				class="lang-item bsg-lang-button"
				role="radio"
				[attr.aria-checked]="languageEnum.GreatBritain === translate.currentLang"
				tabindex="0"
			>
				<ion-icon src="../../../assets/dean_and_david/lang/gb.svg" aria-hidden="true"></ion-icon>
				<h3>{{ 'EN' | translate }}</h3>
			</button>

			<button
				[class.selected]="languageEnum.Czech === translate.currentLang"
				(click)="changeLang(languageEnum.Czech)"
				class="lang-item bsg-lang-button"
				role="radio"
				[attr.aria-checked]="languageEnum.Czech === translate.currentLang"
				tabindex="0"
			>
				<ion-icon src="../../../assets/dean_and_david/lang/cs.svg" aria-hidden="true"></ion-icon>
				<h3>{{ 'CZ' | translate }}</h3>
			</button>
		</div>

		<!-- Logout button -->
		<button *ngIf="!customer?.isAnonymous" class="logout bsg-logout-button" (click)="logout()" aria-label="Logout" tabindex="0">
			<ion-icon src="../../../assets/dean_and_david/burger-menu/logout.svg" aria-hidden="true"></ion-icon>
		</button>
	</div>
</div>
